import { Registry } from '@react-registry'

export const H3Deserializer = () => {
  return {
    type: 'h3'
  }
}

Registry.register(H3Deserializer, { id: 'H3', registry: 'v2.deserializer' })
